import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import type { UserContact } from '@shared/models/user';
import { Icon } from '@tvd/design-system/icon';
import { NamePipe } from '@tvd/ui/name';

@Component({
  selector: 'tvd-avatar',
  imports: [NamePipe, Icon],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      [class]="sizeClass()"
      class="bg-linear-primary-accent rounded-full flex items-center justify-center zyn-white-text font-semibold select-none"
    >
      @let initials = user() | name: 'initials';
      @if (user().profileImageUrl) {
        <img
          [src]="user().profileImageUrl"
          [alt]="user() | name"
          draggable="false"
          class="object-cover rounded-full select-none"
        />
      } @else if (initials) {
        {{ initials }}
      } @else {
        <tvd-icon icon="person" class="text-xl" />
      }
    </div>
  `,
})
export class Avatar {
  readonly user = input.required<UserContact>();
  readonly size = input<'sm' | 'md' | 'lg' | 'xl'>('sm');

  readonly sizeClass = computed(() => {
    const size = this.size();
    switch (size) {
      case 'sm':
        return 'text-xs size-8';
      case 'md':
        return 'text-md size-12';
      case 'lg':
        return 'text-lg size-16';
      case 'xl':
        return 'text-5xl size-32';
    }
  });
}
